import { useLocation } from '@remix-run/react';

export function useUrlWithQueryParams(baseUrl: string, allowedParams: string[]) {
    const { search } = useLocation();

    const src = new URLSearchParams(search);
    const dst = new URLSearchParams();

    for (const key of allowedParams) {
        const value = src.get(key);
        if (value !== null) {
            dst.set(key, value);
        }
    }

    const qs = dst.toString();
    return qs ? `${baseUrl}?${qs}` : baseUrl;
}
